import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5 2a1 1 0 0 0-.943.667l-3.5 9.9A1 1 0 0 0 5 13.9h4.136l-.755 6.993a1 1 0 0 0 1.766.742l9.625-11.7A1 1 0 0 0 19 8.3h-5.06l1.399-5.032A1 1 0 0 0 14.375 2z"
    }, null, -1)
  ])))
}
export default { render: render }